<script setup lang="ts">
import { cn } from "@/lib/utils"
import { onMounted, ref } from "vue"
import useResponsive from "@/composables/useResponsive"

const props = defineProps({
  class: {
    type: String,
    default: "",
  },
  sticky: {
    type: Boolean,
    default: true,
  },
})
const isMounted = ref(false)

const { smallerThanMd } = useResponsive()

onMounted(async () => {
  isMounted.value = true
})
</script>

<template>
  <Teleport v-if="isMounted && smallerThanMd && props.sticky" to="#app">
    <div
      :class="
        cn(
          'fixed right-0 bottom-0 left-0 flex items-center justify-center gap-4 bg-white px-5 py-4',
          props.class
        )
      "
    >
      <slot />
    </div>
  </Teleport>
  <div
    v-else
    :class="
      cn(
        'flex flex-col items-center justify-center gap-4 sm:flex-row',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
